type AdminProgressBarProps = {
  /** 進捗率 0〜1 */
  value: number;
  /** バーの幅（デフォルト: 100%） */
  width?: string;
  /** 残り日数（90日以内で赤表示、0日でグレー） */
  remainingDays?: number | null;
};

/** 進捗バー */
export default function AdminProgressBar({ value, width, remainingDays }: AdminProgressBarProps) {
  const percent = `${Math.round(Math.min(Math.max(value, 0), 1) * 100)}%`;
  const isExpired = remainingDays === 0;
  const isWarning = !isExpired && remainingDays != null && remainingDays <= 90;

  // 期限切れ: グレー、90日以内: 赤、それ以外: 青
  const barColor = isExpired ? 'bg-[#696969]' : isWarning ? 'bg-[#ff4e4e]' : 'bg-[#4188ff]';
  const bgColor = 'bg-[#e1e1e1]';

  return (
    <div className={`h-1 rounded-full ${bgColor}`} style={width ? { width } : undefined}>
      <div className={`h-1 rounded-full ${barColor} ml-auto`} style={{ width: percent }} />
    </div>
  );
}
